import { Trans } from "@lingui/react/macro";
import placeImg from "../../assets/images/lead_place.webp"
import placeImgGold from "../../assets/images/lead_place_gold.webp"
import placeImgSilver from "../../assets/images/lead_place_silver.webp"
import placeImgBronze from "../../assets/images/lead_place_bronze.webp"
import bgImg from "../../assets/images/lead_bg.webp"
import bgImgGold from "../../assets/images/lead_bg_gold.webp"
import bgImgSilver from "../../assets/images/lead_bg_silver.webp"
import bgImgBronze from "../../assets/images/lead_bg_bronze.webp"
import prizeImg from "../../assets/images/lead_prize.webp"
import prizeImgGold from "../../assets/images/lead_prize_gold.webp"
import prizeImgSilver from "../../assets/images/lead_prize_silver.webp"
import prizeImgBronze from "../../assets/images/lead_prize_bronze.webp"
import imgCoin from "../../assets/images/coin.webp"
import imgTicket from "../../assets/images/main_ticket.webp"
import logoUSDT from "../../assets/images/logo_usdt.webp"
// import avaImg1 from "../../assets/images/ava_default_1.webp"
// import avaImg2 from "../../assets/images/ava_default_2.webp"
import avaImg3 from "../../assets/images/ava_default_3.webp"
import s from './LeadersScreen.module.css'
import { Leader } from "../../redux/types";


type LeadersListProps = {
    leadersData: Leader[];
};

const LeadersList: React.FC<LeadersListProps> = ({ leadersData }) => {
    const getResourceByPlace = (place: number, type: "place" | "background" | "prize") => {
        const resources = {
            place: [placeImgGold, placeImgSilver, placeImgBronze, placeImg],
            background: [bgImgGold, bgImgSilver, bgImgBronze, bgImg],
            prize: [prizeImgGold, prizeImgSilver, prizeImgBronze, prizeImg],
        };

        const defaultIndex = 3;
        const resourceArray = resources[type];
        return resourceArray[Math.min(place - 1, defaultIndex)];
    };

    const getValidAvatar = (avatar: string | undefined | null): string => {
        return avatar && typeof avatar === "string" && avatar.trim() !== "" ? avatar : avaImg3;
    };

    return (
        <div className={s.listWrapper}>
            <div className={s.tableHeaderBox}>
                <p className={s.tableHeaderText}><Trans>rank</Trans></p>
                <p className={`${s.tableHeaderText} ${s.flexGrow}`}><Trans>name</Trans></p>
                <p className={s.tableHeaderText}><Trans>PRIZE IN USDT</Trans></p>
            </div>


            <div className={s.listContainer}>
                {leadersData.map(({ avatar, username, tokens, tickets, reward }, index) => {
                    const place = index + 1;
                    const validAvatar = getValidAvatar(avatar);
                    const formatNumbers = (num: number): string => {
                        if (isNaN(num)) return "0";
                        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                    return (
                        <div className={s.listItem} style={{ backgroundImage: `url(${getResourceByPlace(place, "background")})` }} key={index}>
                            <div className={s.placeBox} style={{ backgroundImage: `url(${getResourceByPlace(place, "place")})` }}>
                                <p className={s.placeText}>{place}</p>
                            </div>
                            <img className={s.imgAva} src={validAvatar} alt={`${username} avatar`} />
                            <div className={s.listTextBox}>
                                <p className={s.textName}>{username}</p>
                                <div className={s.listBox}>
                                    <div className={`${s.listInnerBox} ${s.flexGrow}`}>
                                        <img className={s.imgCoin} src={imgCoin} alt="coin" />
                                        <p className={s.textCoin}>{formatNumbers(tokens)}</p>
                                    </div>
                                    <div className={s.listInnerBox}>
                                        <img className={s.imgTicket} src={imgTicket} alt="ticket" />
                                        <p className={s.textTicket}>{tickets}</p>
                                    </div>
                                </div>
                            </div>
                            <img className={s.imgLogo} src={logoUSDT} alt="logoUSDT" />

                            <div className={s.prizeBox} style={{ backgroundImage: `url(${getResourceByPlace(place, "prize")})` }}>
                                <p className={s.textPrize}>{reward}$</p>
                            </div>
                        </div>
                    )
                })}
                <div className={s.placeholder}></div>
            </div>
            <div className={s.frostedGlass}> </div>
        </div>
    )
}

export default LeadersList